/* eslint-disable */
import { DeliveryDates } from '../models/delivery.dates.model';
import { mockItemOfferData } from './item.offer.mock';
import { Service } from '../models/service.model';
import { ReplacementOffer } from '../models/replacement.offer.model';
import { of } from 'rxjs';
export class MockOfferService {
  readonly offerReference$ = of();
  readonly offersState$ = of();
  readonly offers$ = of();
  readonly offersLoading$ = of();
  readonly offersLoaded$ = of();
  readonly deliveryAddress$ = of();
  readonly comparisons$ = of();
  readonly selected$ = of();
  readonly selectedFilteredOffers$ = of();
  readonly itemOfferState$ = of();
  readonly itemOffer$ = of(mockItemOfferData);
  readonly itemOfferError$ = of();
  readonly itemOfferLoading$ = of();

  readonly itemOfferLoaded$ = of();

  readonly itemOfferUpsell$ = of();

  readonly extras$ = of();

  readonly isInstallationSelected$ = of();
  readonly isDisposalSelected$ = of();
  readonly isDeliverySelected$ = of();
  readonly isProtectionSelected$ = of();
  readonly isDeclineProtectionSelected$ = of();
  readonly isTermsConditionsSelected$ = of();
  readonly isInstallationAvailable$ = of();
  readonly isDisposalAvailable$ = of();
  readonly isDeliveryAvailable$ = of();
  readonly getInstallation$ = of();
  readonly getDisposal$ = of();
  readonly getDelivery$ = of();
  readonly isInstallationUpsellAvailable$ = of();
  readonly isDisposalUpsellAvailable$ = of();
  readonly isUpsellAvailable$ = of();
  readonly currentPlan$ = of();
  readonly contact$ = of();
  readonly selectOffersDeliveryDatesKeys$ = of();
  readonly selectOffersDeliveryDatesEntities$ = of();
  readonly selectOffersDeliveryDates$ = of();
  readonly selectOffersDeliveryDatesById$ = of();
  readonly isNextDayDeliveryAvailable$ = of();

  filterOffers(selected, offers = [] as ReplacementOffer[]) {}

  filterOfferSelected(selected, offers = [] as ReplacementOffer[]) {}

  setOfferReference(payload: string) {}

  clearOfferReference() {}

  loadOffers(payload?: string) {}

  resetOffers() {}

  loadItemOffer() {}

  clearComparisons() {}

  selectOffer(payload: ReplacementOffer) {}

  addExtra(payload: Service) {}

  removeExtra(payload: Service) {}

  resetExtras() {}

  addProtection() {}

  resetProtection() {}

  agreeTermsConditions() {}

  resetTermsConditions() {}

  declineProtection() {}

  resetDeclineProtection() {}

  loadOffersDeliveryDates(payload: ReplacementOffer) {}

  isNextDayDeliveryAvailable(dates: DeliveryDates) {}
}
